var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBookmarkOn = function SvgIcBookmarkOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.5 1.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15.168a1 1 0 0 1-1.54.841l-4.92-3.161a1 1 0 0 0-1.08 0l-4.92 3.161a1 1 0 0 1-1.54-.84z"
  })));
};
export default SvgIcBookmarkOn;